<template>
	<div data-tour-scope="bought-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.bought') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- <v-divider vertical></v-divider>-->
								<v-btn text data-tour="new" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>

							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="3" data-tour="date">
									<v-menu v-model="dataordine" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatejs" v-on="on" outlined dense clearable @click:clear="cleardate" label="Data ordine" hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.created_at" @change="dataordine = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3" data-tour="supplier">
									<v-autocomplete
										v-model="settings.filters.supplier"
										item-text="Company"
										item-value="_id"
										:items="chooseSuppliers"
										:menu-props="{ maxHeight: '400' }"
										label="Fornitore"
										outlined
										clearable
										dense
										hide-details
									></v-autocomplete>
								</v-col>
							</v-row>
						</v-col>

						<!--						<v-card v-if="selectedchecbox.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selectedchecbox.length }}
									<span v-if="selectedchecbox.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="eliminaCorrispettivo(null)" v-if="InvoiceItem && TypeInvoice === 'sales_receipt' && selectedchecbox.length === 1 && fattureincloud"> Elimina Corrispettivo </v-tab>
								<v-tab @click="rimborsaCorrispettivo(null)" v-if="InvoiceItem && TypeInvoice === 'sales_receipt' && selectedchecbox.length === 1 && fattureincloud"> Rimborsa Corrispettivo </v-tab>
								<v-tab @click="eliminaFattura(null)" v-if="InvoiceItem && TypeInvoice === 'Fattura' && selectedchecbox.length === 1 && fattureincloud"> Elimina Fattura </v-tab>
								<v-tab @click="creaCorrispettivo(null)" v-if="!InvoiceItem && selectedchecbox.length === 1 && fattureincloud"> Crea Corrispettivo </v-tab>
								<v-tab @click="creaFattura(null)" v-if="!InvoiceItem && selectedchecbox.length === 1 && fattureincloud"> Crea Fattura </v-tab>
							</v-tabs>
						</v-card>-->

						<v-data-table
							v-model="selectedall"
							data-tour="table"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:mobile="isMobile"
							@input="toggle"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="bought-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card class="bought-card" :title="fornitore(item) || 'Fornitore non indicato'" :fields="campiCard(item)" @click="editItem(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu" @click.stop>
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-detail" @click="editItem(item)">
																<v-list-item-title class="size9">Dettaglio</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun documento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-detail" @click="editItem(item)">
															<v-list-item-title class="size9">Dettaglio</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>

											<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
											<td>{{ item.id }}</td>
											<td>{{ item.FatturaElettronicaBody?.DatiGenerali?.DatiGeneraliDocumento?.Data | moment('DD/MM/YYYY') }}</td>

											<td>{{ item.FatturaElettronicaHeader?.CedentePrestatore?.DatiAnagrafici?.Anagrafica?.Denominazione }}</td>
											<td>{{ item.FatturaElettronicaBody?.DatiGenerali?.DatiGeneraliDocumento?.Numero }}</td>
											<td>{{ item.FatturaElettronicaBody?.DatiGenerali?.DatiGeneraliDocumento?.ImportoTotaleDocumento }}</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createBoughtListTourSteps, stopBoughtListTour } from './bought-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100, 250, 500, 750, 1000];

export default {
	name: 'Order',
	// pagina, righe, ordinamento, ricerca e filtri stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { supplier: 'string', created_at: 'array' }, perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita' da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createBoughtListTourSteps(), { onStop: stopBoughtListTour }),
		};
	},
	data() {
		return {
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,
			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					supplier: '',
					created_at: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),

			listSize: LIST_SIZE,
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },
				{ text: 'Data', value: 'created_at' },
				{ text: 'ID Ordine', value: 'id' },
				{ text: 'Data emissione', value: 'FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data' },

				{ text: 'Fornitore', value: 'FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione' },
				{ text: 'Numero', value: 'FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero' },
				{ text: 'Importo', value: 'FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento' },
				// {text: 'Packaging',      value: 'Packaging' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			chooseSuppliers: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			invoice_types: [
				{ text: 'Ordini con corrispettivi', value: 'sales_receipt' },
				{ text: 'Ordini con fattura', value: 'invoice' },
				{ text: 'Ordini da sincronizzare', value: 'null' },
			],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	created() {},
	async mounted() {
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}nocors/orders/download`;

		let promises = [];
		promises.push(this.fetchSetting());
		promises.push(this.fetchSupplier());

		const result = await Promise.all(promises);
		this.chooseSuppliers = result[1].data;
		this.listLoad();
	},
	components: {
		KeyValueCard,
		TourOverlay,
	},
	computed: {
		// sotto i 769px (stessa soglia di onResize) le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'fattureelettroniche/getItems',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'fattureelettroniche/getIndex',
			getSortBy: 'fattureelettroniche/getSortBy',
			getSortDesc: 'fattureelettroniche/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getServices: 'services/getServices',
			getSettings: 'settings/getSetting',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		filteredItems() {
			let filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
				}
				return d;
			});

			let sum;
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let total = 0;
				let refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}
			return filters;
		},
		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
		computedDatePrepjs() {
			let arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},
	methods: {
		fornitore(item) {
			return item.FatturaElettronicaHeader?.CedentePrestatore?.DatiAnagrafici?.Anagrafica?.Denominazione;
		},
		// stessi campi e formati delle colonne della tabella desktop
		campiCard(item) {
			const documento = item.FatturaElettronicaBody?.DatiGenerali?.DatiGeneraliDocumento || {};
			const data = value => (value ? this.$moment(value).format('DD/MM/YYYY') : '');
			return [
				{ label: 'Numero', value: documento.Numero },
				{ label: 'Data emissione', value: data(documento.Data) },
				{ label: 'Importo', value: documento.ImportoTotaleDocumento, strong: true },
				{ label: 'Data', value: data(item.created_at) },
				{ label: 'ID Ordine', value: item.id },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'fattureelettroniche/setItems',
			setOrder: 'fattureelettroniche/setItem',
			setIndex: 'fattureelettroniche/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setSnackbarApp: 'settings/setSnackbar',
		}),
		...mapActions({
			fetchOrders: 'fattureelettroniche/asyncFetchData',

			destroyData: 'fattureelettroniche/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			fetchSupplier: 'suppliers/fetchLists',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',

			fetchPackagings: 'packagings/getListings',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',
		}),
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				var re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},
		async creaOrdineFornitore() {
			this.dialogOrderSupplier = true;
		},

		// inserimento e dettaglio sono pagine: la lista resta nel suo URL e ci si torna uguale
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/bought/new');
		},

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				if (event[0] !== -1) {
					this.selectedchecbox = [];
					_.forEach(this.getOrders, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		copy(field) {
			let input = document.createElement('input');
			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			let sc = 0;
			if (!iva || iva === 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
			}
			return sc;
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
			this.settings.filters.preparation_date = [];
		},

		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/bought/${item._id}`);
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;

				let items = this.fetchOrders(this.settings);
				items.then(result => {
					this.total = result.total;
					//this.items = result.data.data
					this.setPreload(false);
					this.selectedchecbox = [];
					this.selectedall = [];
				});
			} catch (err) {
				console.log(err);
			}
		},

		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		creaFattura(key) {
			this.componentKey += 1;
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			this.operation = 'FormCreateInvoice';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		rimborsaCorrispettivo(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/rimborsaCorrispettivi';
			let payload = item;
			this.setPreload(true);
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.setPreload(false);
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;

						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		creaNotaDiCredito(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/creaNotadicredito';
			let payload = item;
			this.setPreload(true);
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.setPreload(false);
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;

						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		eliminaInvoice(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.setPreload(true);
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		eliminaCorrispettivo(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaCorrispettivi';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		async downloadReviewById() {
			this.errorDownloadReview = '';
			this.loadingDownload = true;
			let result = await this.getOrdersReview({ id_start: this.idStart, id_end: this.idEnd });
			this.loadingDownload = false;

			if (_.size(result.orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(result.orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                  if(item.kits && item.kits.length > 0){

                    textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                    _.forEach(item.kits, (kit) =>{
                      textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                    })

                  }else{

                   */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			} else {
				this.errorDownloadReview = 'Gli Id Ordini indicati non risultano corretti per individuare un range';
			}
		},

		async downloadReview() {
			let orders = _.filter(this.getOrders, o => {
				return this.selectedchecbox.includes(o._id);
			});

			if (_.size(orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                    if(item.kits && item.kits.length > 0){

                      textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                      _.forEach(item.kits, (kit) =>{
                        textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                      })

                    }else{

                     */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			}
		},
		eliminaFattura(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			let delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				let fromDate = parseInt(new Date().getTime() / 1000);
				let toDate = parseInt(new Date(delivery).getTime() / 1000);
				let timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				let box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			this.preload = true;
			let url = 'auth/delete';

			this.messages = [];

			axios
				.delete(`${this.getUrl}${url}/${this.form._id}`, { headers: { Authorization: `Bearer ${this.getToken}` } })

				.then(() => {
					const index = this.items.indexOf(this.form);
					this.items.splice(index, 1);
					this.deleteitem = '';
					this.snackbar.color = 'success';
					this.snackbar.text = 'Utente Eliminato con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					//confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
					//this.form.permission=pluck(res.data.permissions,id);
					this.preload = false;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							console.log(errors);
							errors.forEach(value => {
								console.log(value.msg);
								this.messages[value.param] = value.msg;
							});
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getPackage(Packaging) {
			if (Packaging !== undefined) {
				return Packaging.name;
			} else {
				return 'n.d.';
			}
		},
		getPackageFromColor(color) {
			switch (color) {
				case 'grey':
					return 'n.d.';
				case 'red':
					return 1;
				case 'pink':
					return 2;
				case 'purple':
					return 3;
				case 'indigo':
					return 4;
				case 'blue':
					return 5;
				case 'green':
					return 6;
				case undefined:
					return 'n.d.';
				default:
					return 'n.d.';
			}
		},
		getPayment(payment) {
			switch (payment) {
				case 'american express':
				case 'creditcard':
				case 'maestro':
				case 'mastercard':
				case 'paypal':
				case 'visa':
					return 'Pagato';
				case 'bonifico bancario':
					return 'Bonifico';
				case 'cash on delivery (cod)':
				case 'cash on delivery cod':
				case 'cod':
					return 'Contrassegno';
				default:
					return payment;
			}
		},
		getStatusColor(statusId) {
			if (statusId && statusId._id) {
				let status = _.find(this.status, { value: statusId._id });
				return status ? status.color : '#FFFFFF';
			} else {
				return '#FFFFFF';
			}
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
.bought-cards tr,
.bought-cards tr:hover {
	background: transparent !important;
}

/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.bought-cards,
.bought-cards tr {
	display: block;
	width: 100%;
}
.bought-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}

/* respiro tra le card e il bordo della card che contiene la tabella */
.bought-cards tr:first-child td {
	padding-top: 12px !important;
}

.bought-cards tr:last-child td {
	padding-bottom: 12px !important;
}
</style>
